export default function hexToRgba(hex: string, a: any) {

  let hexCode = hex.replace('#', '');

  if (hexCode.length === 3) {
    hexCode += hexCode;
  }

  const r = parseInt(hexCode.substring(0, 2), 16);
  const g = parseInt(hexCode.substring(2, 4), 16);
  const b = parseInt(hexCode.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${a / 100})`;
}
